type TwoLineCellProps = {
  primary: string;
  secondary?: string;
};

function TwoLineCell({ primary, secondary }: TwoLineCellProps) {
  return (
    <>
      <div className="diagnostics-cell-primary">{primary}</div>
      {secondary === undefined ? null : <div className="diagnostics-cell-secondary">{secondary}</div>}
    </>
  );
}

export default TwoLineCell;
